export class TTPSharedDetail {
  name: string;
  changeTextName: string;
  isShared: boolean;
  timeAuthorised: String;
  timeReleased: String = '';
  entryLocation: string;
}
